import { render, staticRenderFns } from "./infos-shop-ticket.vue?vue&type=template&id=441d5442"
import script from "./infos-shop-ticket.vue?vue&type=script&lang=ts"
export * from "./infos-shop-ticket.vue?vue&type=script&lang=ts"
import style0 from "./infos-shop-ticket.vue?vue&type=style&index=0&id=441d5442&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('441d5442')) {
      api.createRecord('441d5442', component.options)
    } else {
      api.reload('441d5442', component.options)
    }
    module.hot.accept("./infos-shop-ticket.vue?vue&type=template&id=441d5442", function () {
      api.rerender('441d5442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/infos-shop-ticket.vue"
export default component.exports